export default {
  mounted() {
    this.handleEvent("check_url", ({ uri, id }) => {
      return {}
    })
  }
}
